import type { StepKey } from './steps';

// Manual-completion storage shared with the Widget. Steps that aren't
// auto-detectable from data (preview, share, guests, reports) can still
// be marked done by the user simply visiting the page or hitting the
// relevant button — call markStepSeen('guests') on /admin/guests load,
// markStepSeen('share') in the Copy-Link click handler, etc.
//
// Writes to localStorage and fires a CustomEvent so the Widget can re-
// read the map immediately. The native `storage` event doesn't fire on
// same-tab writes, hence the custom event.

const MANUAL_KEY = 'onark-onboarding-manual-completed';

export const STEP_SEEN_EVENT = 'onark:onboarding-step-seen';

export function markStepSeen(step: StepKey) {
  if (typeof window === 'undefined') return;
  try {
    const raw = localStorage.getItem(MANUAL_KEY);
    const map: Record<string, boolean> = raw
      ? (JSON.parse(raw) as Record<string, boolean>)
      : {};

    if (map[step]) return; // already marked — no work, no event
    map[step] = true;
    localStorage.setItem(MANUAL_KEY, JSON.stringify(map));
    window.dispatchEvent(new Event(STEP_SEEN_EVENT));
  } catch {
    // ignore
  }
}
